import React from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { WebSocketProvider } from './features/real-time-updates/WebSocketProvider'
import { MainLayout } from './shared/layout/MainLayout'
import { DashboardPage } from './pages/dashboard'
import { IncidentsPage } from './pages/incidents'
import { MessagesPage } from './pages/messages'
import { BalancesPage } from './pages/balances'
import { SettingsPage } from './pages/settings'
import { AnalyticsPage } from './pages/analytics'
import { AboutPage } from './pages/about'
import { ExecutiveDashboardPage } from './pages/executive-dashboard'
import './app/styles/globals.css'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10000,
      refetchInterval: 15000,
      refetchOnWindowFocus: true,
      retry: 3,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000)
    }
  }
})

export function App() {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <WebSocketProvider>
            <Routes>
              {/* Главный layout со sidebar */}
              <Route element={<MainLayout />}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/incidents" element={<IncidentsPage />} />
                <Route path="/messages" element={<MessagesPage />} />
                <Route path="/balances" element={<BalancesPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/about" element={<AboutPage />} />
              </Route>
              
              {/* Отдельная страница без layout */}
              <Route path="/executive" element={<ExecutiveDashboardPage />} />
              
              {/* 404 */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <ReactQueryDevtools initialIsOpen={false} />
          </WebSocketProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>
  )
}